<template>
	<div v-if="response">

		<div class="row company-view">
			<div class="col-12">
				<div class="row tit_page">
					<div class="col-12">
						<div class="float-left">
							<h1>Investimento Social <span>id#{{ ajustIdOportunidade(impact.IdOportunidade, 5) }}</span></h1>
						</div>
						<div class="back float-right">
							<router-link to="/investimentos/investimento-de-impacto" title="Voltar"><i>&nbsp;</i> voltar</router-link>
						</div>
						<div class="clearfix"></div>
					</div>
				</div>
				<hr class="divider">

				<div class="row">

					<!-- Inicio conteúdo -->
					<div class="col-12 col-md-8 col-lg-8">
						<div class="tit">
							<h2>{{ impact.Impacto.NomeEmpresa}}</h2>
							<span>{{ impact.Nome }} – {{ impact.Impacto.Cidade }} / {{ impact.Impacto.UF }}</span>
							<small>{{ impact.Impacto.AreaEmpresa }}</small>  
						</div>

						<div class="embed-responsive embed-responsive-16by9">
							<iframe class="embed-responsive-item" :src="impact.Impacto.VideoDetalhes" allowfullscreen></iframe>
						</div>

						<section class="entry">
							<div class="row">
								<div class="col-12 col-md-6">
									<div class="box">
										<label>Valor do Financiamento</label>
										<p>R$ {{ formatCurrency(impact.Valor) }}</p>
									</div>
								</div>
								<div class="col-12 col-md-6">
									<div class="box">
										<label>Previsão de retorno do empréstimo</label>
										<p>{{ impact.Prazo }} mês</p>
									</div>
								</div>								
							</div>
							<div v-html="impact.Impacto.InformacaoInstitucional"></div>
						</section>

						<section class="info-impact">
							<at-tabs>
								<at-tab-pane label="Campanha" name="campanha">
									<h3>Palavras do(a) Empreendedor(a)</h3>
									<div v-html="impact.Impacto.Campanha"></div>
								</at-tab-pane>
							</at-tabs>
						</section>
					</div>
					<!-- Final conteúdo -->

					<!-- Inicio sidebar -->
					<aside class="col-12 col-md-4 col-lg-4">
						<div class="box">
							<div class="row no-gutters dates">
								<div class="col-12 col-sm-6">
									<img src="/static/assets/images/ico-calendar_ok.svg">
									<label>Início</label>
									<span class="date">{{ formatMongoDate(impact.InicioCaptacao) }}</span>
								</div>
								<div class="col-12 col-sm-6">
									<img src="/static/assets/images/ico-calendar_end.svg">
									<label>Término</label>
									<span class="date">{{ formatMongoDate(impact.FimCaptacao) }}</span>
								</div>          
							</div>

							<hr class="divider">

							<div class="row">
								<div class="col-12 text-center">
									<label>Valor solicitado</label>
									<span class="value">R$ {{ formatCurrency(impact.Valor) }}</span>
								</div>
							</div>

							<hr class="divider">

							<div class="row">

								<div class="col-6 text-center">
									<label>Duração esperada</label>
									<span class="info bold">{{ impact.Prazo }} Mês</span>
								</div>

								<div class="col-6 text-center">
									<label>Taxa de Juros Mensal</label>
									<span class="info bold">{{ formatCurrency(impact.TaxaJuros) }} %</span>
								</div>

							</div>

							<hr class="divider">

							<div class="row no-gutters text-center">
								<div class="col-12">
									<h5>{{ calcDiasRestantes() }}</h5>
								</div>
								<div class="col-12">
									<div class="clearfix itens">
										<span class="float-left">Levantado: {{ formatCurrency(impact.ValorCaptado) }}</span>
										<span class="float-right">Faltam: <strong>R$ {{ formatCurrency(calcValorRestante(impact)) }}</strong></span>
									</div>
									<div class="progress">
										<div class="progress-bar" role="progressbar" :style="'width:' + calcPercValorRestante(impact) + '%'" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
											<span class="progress-value">{{ formatCurrency(calcPercValorRestante(impact)) }}%</span>
										</div>
									</div>
								</div>
								<div class="col-12">
									<span class="info__invest"><strong>{{ impact.QuantidadeReservasInvestimento }}</strong> investidores</span>
								</div>
							</div>

							<hr class="divider">

							<div class="row no-gutters text-center">
								<div v-if="canInvest" class="col-12 text-center">
									<div v-if="!impact.JaInvestiu && showInputInvestment">
										<form @submit.prevent="proximoPasso()">
											<div v-if="permiteAporte" class="form-group">
												<label for="valor">Valor que deseja aportar</label>
												<input class="form-control form-control-lg" id="valor" v-model="valorInv" v-mask="'money'" :placeholder="'Investimento mínimo R$ '+ money(this.impact.InvestimentoMinimo)">
											</div>


											<button v-if="this.InvestidorBloqueado()" class="btn btn-lg btn-danger btn-block" style="cursor: not-allowed;" disabled>Bloqueado</button>
											<button v-if="permiteAporte && !this.InvestidorBloqueado()" type="button" @click="ShowSaldo()" class="btn btn-primary btn-lg btn-block">Apoiar</button>

										</form>
										<p class="small">
										</p>
									</div>

									<!-- CARTEIRA VIRTUAL REINVESTIMENTO -->
									<form v-show="showInputSaldo" v-if="canInvest && !impact.JaInvestiu">
										<div class="reinvestir" v-if="permiteAporte">
											<img src="/static/assets/images/ico-reinvestir.svg" alt="icone reinvestir">
											<p>
												{{Nome()}}, essa oportunidade é somente para quem tem saldo na carteira. Gostaria de investir?
											</p>
											<label>Total disponível para investir</label>
											<span>R$ {{formatCurrency(this.sDisponivel)}}</span>
										</div>

										<div class="form-group" v-if="permiteAporte">
											<label for="valor">Valor que dejesa utilizar</label>

											<!-- <input v-model="valorReinvestimento" class="form-control form-control-lg" id="valor" :placeholder="'Investimento mínimo R$ 100,00'" v-mask="'money'"> -->
											<at-select size="large" v-model="selected" placeholder="Selecione um valor ...">
												<at-option v-for="option in values" :key="option" :value="option">{{ option }}</at-option>
											</at-select>

											<p class="small">
												O valor para reinvestimento não pode ser superior ao disponível em sua carteira virtual.
											</p>
										</div>   

										<button v-if="permiteAporte" class="btn btn-primary btn-lg btn-block"  @click.prevent="UsarSaldo()">Investir</button>
										<button v-if="this.InvestidorBloqueado()" class="btn btn-lg btn-danger btn-block" style="cursor: not-allowed;" disabled>Bloqueado</button>
										<button v-if="!permiteAporte && !this.InvestidorBloqueado()" type="button" class="btn b tn-primary btn-lg btn-block" style="background-color: gray;">Encerrado</button>										
									</form>

									<div v-if="impact.JaInvestiu" style="width: 100%">
										<div class="alert alert_reserve alert-warning text-center" style="width: 100%">
											<h2>Você já efetuou um aporte para este investimento.</h2>
										</div>
									</div>
								</div>

								<div v-else class="form-row" style="width: 100%">
									<div class="alert alert_reserve alert-warning text-center" style="width: 100%">
										<h2>Falta pouco para você investir</h2>

										<div>
											<p v-if="temCadastroInvestidor && temSuitability && !investidorAprovado" style="font-size: 20px;">Agora estamos analisando suas informações e retornaremos em até 1 dia útil.</p>
											<p v-else>
												<router-link v-if="!temCadastroInvestidor" to="/informacoes-adicionais/investidor" class="btn btn-link">Complete o cadastro de investidor</router-link>
												<router-link v-if="!temSuitability" to="/informacoes-adicionais/suitability" class="btn btn-link">Preencha o formulário de suitability</router-link>
											</p>
										</div>
									</div>
								</div>
							</div>

						</div>
					</aside>
					<!-- Final sidebar -->

				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">
	@import "../assets/styles/iouu/variables";
	@import "../assets/styles/iouu/mixins";


	.info-impact {
		.at-tabs {

			&-nav {
				&__item {
					@include font-size(16px);
					font-weight: bold;
					padding:0px;
					color: #999;

					&:hover {
						color: $black;
					}

					&::after {
						background-color: $c3;
					}

					&--active {
						color: $black;
					}
				}
				
			}

			&__body {
				font-size: 16px;
			}
		}
	}
	
</style>

<style lang="scss" scoped>
	@import "../assets/styles/iouu/variables";
	@import "../assets/styles/iouu/mixins";


    .modal-header {
		> div {
			width: 100%;
		}
        .tit {
            h2 {
                @include font-size(26px);
                letter-spacing: 0px;
            }
        }
	}
	.modal-body {
        .tit {
            h4 {
                @include font-size(16px);
                letter-spacing: 0px;
            }
        }
	}


	table {
		color: #000!important;
		margin:0px;

		thead {
			th {
				border-top: none;
			}
		}

		tr {
			border: none;
		}
	}

	.entry {
		padding: 20px 0;
	}
	
	aside {
		position: relative;

		.box {
			position: sticky;
		}

        .btn {
            &-link {
				text-decoration: underline!important;
                color: #666;
                text-transform: inherit !important;
                font-weight: normal !important;
                &:hover {
                    color: #333;
                }
            }
		}
		
		.alert {
			h2 {
				color: #856404!important;
				@include font-size(24px);
				padding-bottom: 10px;
			}
			p {
				padding:0px!important;
			}
			.btn {
				margin-top:0px;
			}
			a:hover {
				color: #856404;
			}
		}
	}

	.reinvestir {
		border-bottom: 1px solid #DDDDDD;
		margin-bottom: 25px;
		padding-bottom: 20px;

		img {
			width: 60px;
		}

		p {
			font-size: 16px;
			font-weight: normal;
			color: #000;
			padding: 20px 0;
		}

		label {
			color: #888;
			font-size: 14px;
			line-height: 14px;
		}
		span {
			font-weight: 700;
			font-size: 25px;
			line-height: 25px;
		}
	}

	.error {
		input {
			border-color: red;
			color: red;
			margin-bottom: 5px;
			&::placeholder {
				color: red;
			}
		}

		p.small {
			padding:0px;
			margin:0px;
			font-size: 12px;
			color: red;
		}
	}

	@include sm {
		.tit_page {
			h1 {
				&{
					font-size: calcRem(30);
				}

				span {
					font-size: 1rem;
				}
			}
			.back {
				display: none;
			}
		}
		.tit {
			h2 {
				font-size: calcRem(20);
			}
		}
		.company-view {
			section {
				h3 {
					font-size: calcRem(20);
				}

				h2 {
					font-size: calcRem(22);
				}

				span {
					font-size: calcRem(18);
				}
			}
		}
	}

	@include xs {
		.tit_page {
			h1 {
				&{
					font-size: calcRem(20);
				}
				span {
					font-size: calcRem(14);
					padding-left: calcRem(10);
					margin-left: calcRem(10);
					line-height: calcRem(45);
					background-size: 6px;
				}
			}
			.back {
				display: none;
			}
		}

		.tit {
			h2 {
				font-size: calcRem(18);
			}

			span {
				@include font-size(12px);
			}
		}

		.company-view {
			section {
				h3 {
					font-size: calcRem(20);
				}

				h2 {
					font-size: calcRem(22);
				}

				span {
					font-size: calcRem(18);
				}
			}
		}
	}
</style>

<script>
/* eslint-disable */
	import ApiClient from '../utils/api-client';
	import Masker from '@/utils/masker'
	import Modal from "@/components/Modal";
	import ArrayHelper from "@/utils/array-helper";
	import * as mutationTypes from '@/store/mutation-types.js'
	import WalletService from "../services/api/wallet";

	export default {
		data() {
			return {
				investidor: null,
				solicitacaoID: "",
				response: false,
				exibirQuantia: true,
				anonimo: false,
				modalInfoAdicional: false,
				finalizado: true,		
				temCadastroInvestidor: false,
				temSuitability: false,
				investidorAprovado: false,
				permiteAporte: false,		
				qtdeInvestidores: 0,
				valueToInvest: 2000,
				valorCaptado: 0,
				id: 0,
				impact: {},
				ReservaInvestimento: {},
				valorInv : null,
				valorReinvestimento : 0,
				sDisponivel : 0,
				showInputInvestment: false,
				showInputSaldo: true,
				values: [],
				selected: ""
			}
		},

		computed: {
			dataInicio() {
				return this.impact.InicioCaptacao.toLocaleDateString('pt-BR')
			},

			canInvest() {
				return this.temCadastroInvestidor && this.temSuitability && this.investidorAprovado;
			},
			User: function() {
				return this.$store.state.currentUser;
			},
		},

		methods: {
			calcValorRestante(impact) {
				return impact.Valor - impact.ValorCaptado;
			},

			calcPercValorRestante(impact) {
				return impact.ValorCaptado * 100 / impact.Valor;
			},

			calcDiasRestantes() {
				return this.diffDate(new Date(), this.impact.FimCaptacao);
			},

			formatMongoDate(dt) {
				var date = new Date(dt);

				var day = date.getDate();
				var month = date.getMonth() + 1;
				var year = date.getFullYear();

				day =  day > 9 ? day : ('0' + day);
				month =  month > 9 ? month : ('0' + month);

				return day + '/' + month + '/' + year;
			},

			diffDate(d1, d2) {
				var date1, date2;

				if (d1 == "") {
					date1 = new Date();
				} else {
					date1 = new Date(d1);
					date1.setHours(date1.getHours() + date1.getTimezoneOffset() / 60);
				}

				if (d2 == "") {
					date2 = new Date();
				} else {
					date2 = new Date(d2);
					date2.setHours(date2.getHours() + date2.getTimezoneOffset() / 60);
				}


				var timeDiff = date2.getTime() - date1.getTime();
				var diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));

				if (diffDays < 0) return "Encerrado";
				if (diffDays == 0) return "Finaliza hoje*";

				return "Finaliza em " + diffDays + " dias*";
			},

			formatCurrency(value) {

				if(value == null || value == undefined )
					return parseFloat(0).toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2})

				return value.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2})
			},
			money(n) {

				var c = 2,
					d = ",",
					t = ".",
					s = n < 0 ? "-" : "",
					i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
					j = (j = i.length) > 3 ? j % 3 : 0;
				return (
					s +
					(j ? i.substr(0, j) + t : "") +
					i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
					(c ?
						d +
						Math.abs(n - i)
						.toFixed(c)
						.slice(2) :
						"")
				);
			},

			showModal(item) {
				this.selectedItem = item;
				this.modalVisible = true;
				this.modalInfoAdicional = false;
				this.showInputSaldo = false;
				this.showInputInvestment= false;
			},

			closeModal() {
				this.modalVisible = false;
				this.modalInfoAdicional = false;
				this.finalizado = false;
				this.showInputSaldo = false;
				this.showInputInvestment= false;
			},

			dataLonga(data) {
				var date = new Date(data);
				date.setHours(date.getHours() + date.getTimezoneOffset() / 60); //ajustando para o horário gravado no banco
				var options = { year: "numeric", month: "long", day: "numeric" };
				return date.toLocaleDateString("pt-BR", options);
			},

			ajustIdOportunidade(id, qtd) {
				var s = String(id);

				while (s.length < (qtd || 2)) {
					s = "0" + s;
				}

				return s;
			},

			getValorCaptado(solicitacaoId) {
				ApiClient.getValorCaptadoLoanImpact(solicitacaoId).then(response => {
					this.valorCaptado = response.data[0].Total;
				});
			},
			InvestidorBloqueado() {

		
				if(this.$store.state.currentUser == null || this.$store.state.currentUser.investor == null || this.$store.state.currentUser.investor.Bloqueio == null || this.$store.state.currentUser.investor.Bloqueio.FimBloqueio == null)
					return false;

				var FimBloqueio= new Date(this.$store.state.currentUser.investor.Bloqueio.FimBloqueio)
				
				return (FimBloqueio > (new Date()));
			},

			getInvestidor(solicitacaoId) {
				ApiClient.getInvestidorLoanImpact(solicitacaoId).then(response => {
					if(response.data != null && response.data.Status != 0) {
						this.impact.JaInvestiu = true;
						this.impact.ReservaInvestimento = response.data;
						this.impact.ReservaInvestimento.Valor += ",00";

						this.valorInv = this.impact.ReservaInvestimento.Valor;
					} else {
						this.impact.JaInvestiu = false;
					}

					this.$forceUpdate();					
				});
			},
			ShowSaldo(){

				if(!this.ValidarInvestimento())
				{
					return false;
				}

				var value = 0
				if (typeof this.valueToInvest === 'string') {
					var inv = this.valueToInvest.replace(/[^a-zA-Z0-9 ]/g, "");
					value = parseFloat(inv / 100);
				}

				if(this.sDisponivel > 0)
				{
					if(this.sDisponivel > value)
					{
						this.valorReinvestimento = this.money(value || 0)
					}
					else
					{
						this.valorReinvestimento = this.money(this.sDisponivel || 0)
					}

					this.showInputInvestment = false;
					this.showInputSaldo = true;
					return true;
				}

				this.proximoPasso();
				return true;
			},
			NaoUsarSaldo(){

				this.valorReinvestimento = 0;
				this.proximoPasso();
			
				return false;
			},
			ValidarInvestimento(){

				var value = 0
				if( typeof this.valorInv === 'string')
				{
					var inv = this.valorInv.replace(/[^a-zA-Z0-9 ]/g, "");
					value = parseFloat(inv/100);
				}

				if(value == 0 || isNaN(value)) {
					this.$Notify.error({
						title: "Desculpe",
						message: "Por favor, insira um valor."
					});

					return false;
				}

				if(value < 100 || isNaN(value)) {
					this.$Notify.error({
						title: "Desculpe",
						message: "O valor mínimo de aporte é de R$ 100,00."
					});

					return false;
				}

				if((value % 100 != 0) || isNaN(value)) {
					this.$Notify.error({
						title: "Desculpe",
						message: "O valor deve ser multiplo de R$ 100."
					});

					return false;
				}

				if (value > this.impact.Valor ) {
						this.$Notify.error({
							title: "Desculpe",
							message: "O valor de aporte é maior que o solicitado."
						});

						return false;
				}

				if(((this.impact.Valor - this.impact.ValorCaptado) > 0) &&  value > (this.impact.Valor - this.impact.ValorCaptado)) {
					this.$Notify.error({
						title: "Desculpe",
						message: "O valor de aporte é maior que o disponível."
					}); 

					return false;
				}

				return true;

			},
			UsarSaldo(){

				let valor = this.selected.replace("R$", "").trim()
				// valor = valor.replace(",", "")
				// valor = valor.trim()
				// valor = parseFloat(valor/100)
				this.valorReinvestimento = valor;

			    var valorInvestimento = 0;
				if( typeof this.valorReinvestimento === 'string') {
					var reInvestimento = this.valorReinvestimento.replace(/[^a-zA-Z0-9 ]/g, "");
					valorInvestimento = parseFloat(reInvestimento/100);
				}

				var errorMessages;
				if(valorInvestimento <= 0 ) {
					errorMessages = ["Insira um valor para o reinvestimento."]
					this.$Notify.error(ArrayHelper.toSentence(errorMessages));
					return false;
				}

				if(valorInvestimento > this.sDisponivel){
					errorMessages = ["Saldo indisponível para o reinvestimento. Valor máximo: R$ " + this.formatCurrency(this.sDisponivel)]
					this.$Notify.error(ArrayHelper.toSentence(errorMessages));
					return false;
				}

				if(valorInvestimento < 15) {
					errorMessages = ["Valor mínimo para investimento: R$ 15,00 "]
					this.$Notify.error(ArrayHelper.toSentence(errorMessages));
					return false;
				} 

				if(valorInvestimento > 50) {
					errorMessages = ["Valor máximo para investimento: R$ 50,00 "]
					this.$Notify.error(ArrayHelper.toSentence(errorMessages));
					return false;
				} 


				this.valorInv = this.valorReinvestimento;
				this.proximoPasso()
				return false;
			},

			proximoPasso() {

				this.closeModal();
				this.modalInfoAdicional = true;

				if(document.getElementsByTagName("main").length > 0 ){
				   document.getElementsByTagName("main")[0].style.zIndex = "50";
				}

				this.checkout();
			},

			checkout(){
				// let erro = this.validacao()
				// if(erro){
				// 	this.$Notify.error(erro)
				// }else{
					let investimento = this.formataInvestimento(this.valorInv, this.valorReinvestimento)
					let data = this.formataStorage(this.investidor._id, this.solicitacaoID, investimento)
					localStorage.setItem("pre_investimento", JSON.stringify(data))
					this.$router.push("/investimentos/oportunidades/confirmacao/" + this.solicitacaoID)
				// }
            },
 			formataInvestimento(valorInvestimento, valorReinvestimento){
				let Valor, ReInvestimento
				typeof valorInvestimento == 'string' ?
					Valor = Masker.unmaskMoney(valorInvestimento) : 
					Valor = valorInvestimento/100
				//Envia valor de reinvestimento
				typeof valorReinvestimento == 'string' ? 
					ReInvestimento = Masker.unmaskMoney(valorReinvestimento) :
					ReInvestimento = valorReinvestimento
				return { Valor, ReInvestimento }
			},
			formataStorage(idInvestidor, idSolicitacao, investimento){
				return {
					"InvestidorId": idInvestidor,
					"SolicitacaoId": idSolicitacao,
					"Valor": investimento.Valor,
					"ValorReinvestimento": investimento.ReInvestimento
				}
			},


			apoiar(solicitacaoId, valueToInvest) {
				this.closeModal();
				this.modalInfoAdicional = true;

				if(document.getElementsByTagName("main").length > 0 ){
				   document.getElementsByTagName("main")[0].style.zIndex = "50";
				}

				var value = 0
				if( typeof this.valorInv === 'string')
				{
					var inv = this.valorInv.replace(/[^a-zA-Z0-9 ]/g, "");
					value = parseFloat(inv/100);
				}
				
				var valor = 0
				if( typeof this.valorReinvestimento === 'string')
				{
					var reInv = this.valorReinvestimento.replace(/[^a-zA-Z0-9 ]/g, "");
					valor = parseFloat(reInv/100);

					if (valor > value){
						valor = value;
					}
				}

				ApiClient.postApoiarLoanImpact(solicitacaoId, value,valor, this.anonimo, this.exibirQuantia).then(() => {
					this.finalizado = true;

					setTimeout(() => {
						this.get(this.id);
					}, 500);
					
				});
			},

			getListaInvestidores(id) {
				ApiClient.getListaInvestidoresLoanImpact(id).then((response) => {
					var vm = this;

					vm.impact.ListaInvestidores = response.data;
					this.$forceUpdate();
				});
			},

			validaStatusInvestimento() {
				var resultDt = this.diffDate(new Date(), this.impact.FimCaptacao);

				if (resultDt == "ENCERRADO" || this.impact.ValorCaptado >= this.impact.Valor)
					return false;

				return true;
			},

			get(id) {
				ApiClient.getLoanImpactById(id).then((response) => {
					this.impact = response.data;

					this.values = [];
					let valorSelect = 0;
					let valorRestante = this.impact.Valor - this.impact.ValorCaptado;
					let quantidade = (this.impact.InvestimentoMaximo / this.impact.InvestimentoMinimo);

					for(let i=0; (valorRestante > valorSelect && this.impact.InvestimentoMaximo - 5 >= valorSelect); i++) {
						
						this.values.push("R$ " + (15 + 5 * i).toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2}) );
						valorSelect = this.impact.InvestimentoMinimo + 5 * i;
					}

					this.impact.JaInvestiu = false;
					this.impact.ReservaInvestimento = {};
					this.impact.ReservaInvestimento.Valor = "";
					this.permiteAporte = this.validaStatusInvestimento();
									
					ApiClient.getCountLoanImpactInvestors(this.id).then((response) => {
						this.qtdeInvestidores = response.data;
						this.response = true;

						this.getValorCaptado(this.id);
						this.getInvestidor(this.id);
						this.getListaInvestidores(this.id);
						
						if(this.impact.Impacto == null){
							this.impact.Impacto = {};
						}
						this.$forceUpdate();
					});

					this.AtualizarSaldo();
				});
			},
			async getSaldo(){
                this.$store.commit(mutationTypes.START_LOADING)
				try{
					const { data } = await WalletService.GetSaldoWallet();
					this.sDisponivel = data.Saldo
				}catch(e){
					this.sDisponivel = 0.00
				}
				this.$store.commit(mutationTypes.STOP_LOADING)
				return this.sDisponivel
        	},
			AtualizarSaldo() {
				this.getSaldo()
				// ApiClient.getMyAvalibleMoney()
				// 	.then(item => {

				// 		item.data.credito = (item.data.credito).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
				// 		var credito =  parseFloat(item.data.credito) ;

				// 		item.data.debito = (item.data.debito).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
				// 		var debito =  parseFloat(item.data.debito) ;

				// 		this.sDisponivel = credito - debito;
				// 		this.sDisponivel = parseFloat(this.sDisponivel.toFixed(2));

				// 		if(this.sDisponivel < 0.01)
				// 		{
				// 			this.sDisponivel = 0;
				// 		}
						
				// 	});
				},
			Nome() {
				var nome = "";
				
				if (this.User.name == undefined || this.User.name == null || this.User.name == "") {
				nome = this.User.username;
				} else {
				nome = this.User.name;
				}
				nome = nome.trim();
				var primeiroNome = nome.split(" ")[0];
				return primeiroNome[0].toUpperCase() + primeiroNome.toLowerCase().substring(1);
			},
			//tagueamento GA
			taggingGA() {
				this.$ga.page({
					page: '/investimento-de-impacto/perfil-impacto/:id',
					title: 'Impacto',
				})
			},
		},
		beforeCreated() {
			this.$store.dispatch('updateUser')
		},
		async created() {
			this.id = this.$route.params.id;
			this.solicitacaoID = this.id;

			if(this.$store.state.currentUser.investor != null){
				if(typeof this.$store.state.currentUser.investor.Bloqueio != 'undefined')
					window.location.href="#/"
			}

			this.temSuitability = this.$store.state.currentUser.hassuitability;
			this.temCadastroInvestidor = this.$store.state.currentUser.hasinvestor;
			this.investidorAprovado = this.$store.state.currentUser.investor != null && this.$store.state.currentUser.investor.Status == "APROVADO" && this.temCadastroInvestidor;
			this.investidor = this.$store.state.currentUser.investor;

			this.get(this.id);	
			
			//tagueamento GA
			await this.taggingGA();
		},

		components: {
			Modal,
		}
	}
</script>


// WEBPACK FOOTER //
// src/views/EmprestimoSocialNew.vue